<div class="mc-task-comment-icon-container" [ngClass]="sizeClass">
  <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-discussion'"></mat-icon>
  <span *ngIf="!displayParenthesis" class="mc-task-comment-icon-count-text">{{count}}</span>
  <span *ngIf="displayParenthesis" class="mc-task-comment-icon-parenthesis-count-text">({{count}})</span>
</div>
